import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Navbar from '../Navbar';
import Footer from '../Footer';

import Banner from '../sections/home/Banner';
import MainForm from '../sections/home/Mainform';
import Categories from '../sections/home/Categories';

function Home() {

    const navigate = useNavigate();

    useEffect(() => {
        const country_id = localStorage.getItem('country_id');
        if (!country_id) {
            navigate('/country');
        }else{
            const dealer_id = localStorage.getItem('dealer_id');
            if (!dealer_id) {
                navigate('/dealer');
            }
        }
    }, []);

    return (
        <>
        <Navbar />

        <div className="page-home">
            <Banner />
            {process.env.REACT_APP_BRAND_ID === '1' && (
                <div className="container">
                    <section
                        className="home-banner-3d"
                        aria-label="Personalize in 3D"
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL || ''}/images/3d-banner-bg.jpg)` }}
                    >
                        <div className="home-banner-3d__content">
                            <h1>
                                <span language="en">Step inside the world of Ford accessories - Interactive 3D view now available exclusively for Bronco.</span>
                                <span language="ar">ادخل إلى عالم إكسسوارات فورد - عرض ثلاثي الأبعاد تفاعلي متوفر الآن حصريًا لسيارة برونكو.</span>
                            </h1>
                            <h3>
                                <span language="en">Choose your Bronco model and year or explore accessory categories to continue.</span>
                                <span language="ar">اختر طراز سيارتك وسنة الصنع أو استكشف فئات الإكسسوارات للاستمرار.</span>
                            </h3>
                        </div>
                    </section>
                </div>
            )}
            <MainForm />
            <Categories />
        </div>

        <Footer />
        </>
    );
}

export default Home;